<template>
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="22" height="21" rx="4.5" stroke="#DC3030" />
    <path
      d="M16.4091 5H6.59091C6.30158 5 6.0241 5.11493 5.81952 5.31952C5.61493 5.5241 5.5 5.80158 5.5 6.09091V15.9091C5.5 16.1984 5.61493 16.4759 5.81952 16.6805C6.0241 16.8851 6.30158 17 6.59091 17H16.4091C16.6984 17 16.9759 16.8851 17.1805 16.6805C17.3851 16.4759 17.5 16.1984 17.5 15.9091V6.09091C17.5 5.80158 17.3851 5.5241 17.1805 5.31952C16.9759 5.11493 16.6984 5 16.4091 5ZM16.4091 15.9091H6.59091V6.09091H16.4091V15.9091Z"
      fill="#DC3030"
    />
  </svg>
</template>

<script>
export default {
  name: "EndDispatchIcon",
};
</script>

<style></style>
